export const navData = ['/', 'destination', 'crew', 'technology']
